import { render } from "./ConfiguracaoCatalogoFerramenta.vue?vue&type=template&id=35e67d1e&scoped=true"
import script from "./ConfiguracaoCatalogoFerramenta.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoCatalogoFerramenta.vue?vue&type=script&lang=js"

import "./ConfiguracaoCatalogoFerramenta.vue?vue&type=style&index=0&id=35e67d1e&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e67d1e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCard,QIcon,QInput,QScrollArea,QLinearProgress,QTable,QTr,QTh,QTd,QPagination,QDialog,QCardSection});qInstall(script, 'directives', {ClosePopup});
